module.exports = __webpack_public_path__ + "static/Online education-f72a05d3c1ddd9023acc0cfa585376da.png";